/**
 * Soka Shop By Occasion
 * Vanilla JS enhancement for the mobile slider (dot navigation + sync)
 * and Shopify Theme Editor support. No dependencies.
 */

(function () {
  'use strict';

  var SELECTOR = {
    section: '[data-section-type="soka-shop-by-occasion"]',
    track: '[data-soka-occasion-track]',
    card: '[data-soka-occasion-card]',
    dots: '[data-soka-occasion-dots]',
    dot: '[data-soka-occasion-dot]'
  };

  function initSection(section) {
    var track = section.querySelector(SELECTOR.track);
    if (!track) return;

    var isSlider = section.hasAttribute('data-soka-occasion-mobile-slider');
    if (!isSlider) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll(SELECTOR.card));
    var dotsWrap = section.querySelector(SELECTOR.dots);
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll(SELECTOR.dot)) : [];

    if (!cards.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var scrollBehavior = reduceMotion ? 'auto' : 'smooth';
    var isSyncing = false;
    var syncTimeout;

    // Click a dot to scroll to the matching card.
    if (dots.length) {
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(dot.getAttribute('data-index'), 10) || 0;
          var target = cards[index];
          if (!target) return;
          isSyncing = true;
          track.scrollTo({
            left: target.offsetLeft - track.offsetLeft,
            behavior: scrollBehavior
          });
          setActiveDot(index);
          window.clearTimeout(syncTimeout);
          syncTimeout = window.setTimeout(function () {
            isSyncing = false;
          }, 400);
        });
      });
    }

    function setActiveDot(index) {
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }

    // Update active dot on manual swipe using an IntersectionObserver
    // scoped to the horizontal track (accurate + performant, no scroll spam).
    if (dots.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          if (isSyncing) return;
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              var index = cards.indexOf(entry.target);
              if (index > -1) setActiveDot(index);
            }
          });
        },
        {
          root: track,
          threshold: [0.6]
        }
      );

      cards.forEach(function (card) {
        observer.observe(card);
      });
    }

    // Theme Editor: scroll the selected block's card into view within the slider.
    section.addEventListener('shopify:block:select', function (event) {
      var wrapper = event.target.closest(SELECTOR.card);
      if (!wrapper) return;
      wrapper.scrollIntoView({
        behavior: scrollBehavior,
        inline: 'center',
        block: 'nearest'
      });
    });
  }

  function initAll() {
    var sections = document.querySelectorAll(SELECTOR.section);
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-initialize when the section is reloaded in the Theme Editor.
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector
      ? event.target.querySelector(SELECTOR.section) || (event.target.matches(SELECTOR.section) ? event.target : null)
      : null;
    if (section) initSection(section);
  });
})();
